"use client";

import React from "react";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const ventures = [{
  id: "v1",
  title: "Luxury Indian Wedding\n",
  brief: "A spectacular 500-guest luxury wedding\xA0 production Sponsored by Vouge India, featuring a 14m LED video wall,\xA0 full production lighting, and PulseFX\xA0 Sparkular and dry ice effects.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672919/img/pulse_wedding_gala.png",
  isPlaceholder: false,
  link: "/WeddingsGalasPage",
  titleClassName: "absolute inset-0 bg-black/60 transition-colors duration-500 group-hover:bg-black/40 !bg-[url(https://flying-cat.10web.cloud/wp-content/uploads/2026/05/Screenshot-2026-05-20-at-10.40.57.png)]"
}, {
  id: "v2",
  title: "Al-Arab UK Charity Gala Dinner\n",
  brief: "A prestigious 350-guest charity gala\xA0\nattended by celebrities including\xA0\nNadia Sawalha, featuring a 6m x 3m\xA0\nLED video wall and full production.",
  image: "https://flying-cat.10web.cloud/wp-content/uploads/2026/05/Brighten-Enhance-Image.png?v=bd97sebnshn",
  isPlaceholder: false,
  link: "/CorporateLivePage"
}, {
  id: "v3",
  title: "Sumeet Tappoo Live Concert UK Tour",
  brief: "An intimate style concert production for international singer Sumeet Tappoo and his six piece live band featuring full sound engineering, event management and LED Screen Backdrop.",
  image: "https://flying-cat.10web.cloud/wp-content/uploads/2026/05/Brighten-Enhance-Image2.png?v=sknoazwy2yd",
  isPlaceholder: false,
  link: "/PulseFXPage"
}];
export default function SelectedVentures() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="236727" id="the-pulse-portfolio" className="bg-background text-foreground py-4 md:py-8 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8">
        <div ref={headerRef} className={`mb-8 md:mb-12 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-tighter mb-6 uppercase">
            The Pulse <span className="text-primary italic">Portfolio</span>
          </h2>
          <div className="w-24 h-[2px] bg-primary"></div>
        </div>

        <Carousel opts={{
        align: "start",
        loop: false
      }} className="w-full relative">
          <CarouselContent className="-ml-4 md:-ml-8">
            {ventures.map((venture, i) => <CarouselItem key={venture.id} data-index={i} className="pl-4 md:pl-8 md:basis-1/2 lg:basis-1/3">
                <div className="group relative h-[600px] w-full overflow-hidden rounded-md border border-border/40 bg-card transition-all duration-500 hover:border-primary/50 hover:scale-[1.02]">
                  {i === 0 ? <video src={venture.image} autoPlay muted loop playsInline className="absolute inset-0 h-full w-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000 ease-out" /> : <img src={venture.image} alt={venture.title} data-wvc-srcset={`${venture.image}-wvc-srcset`} data-wvc-sizes={`${venture.image}-wvc-sizes`} className="absolute inset-0 h-full w-full object-cover transition-all duration-1000 ease-out group-hover:grayscale-0" loading="lazy" />}

                  <div className={`${venture.titleClassName || ""} absolute inset-0 bg-black/60 group-hover:bg-black/40 bg-cover bg-center transition-colors duration-500`} />

                  <div className="absolute inset-x-0 bottom-0 p-8 flex flex-col justify-end transition-transform duration-500 z-10 group-hover:-translate-y-4">
                    <h3 className="text-3xl font-default font-bold text-secondary mb-3 tracking-tight">
                      {venture.title}
                    </h3>
                    <p className="text-base font-default text-slate-300 leading-relaxed max-w-[90%]">
                      {venture.brief}
                    </p>
                  </div>

                  {venture.isPlaceholder && <div className="absolute top-6 right-6 z-30">
                      <Badge variant="outline" className="rounded-md border-secondary/50 bg-secondary/20 text-secondary backdrop-blur-md shadow-md shadow-secondary/10 px-3 py-1 uppercase tracking-widest text-[10px] font-bold">
                        Live Feed
                      </Badge>
                    </div>}
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex items-center justify-center gap-4 mt-8 md:block">
            <CarouselPrevious className="static md:absolute left-4 md:-left-12 translate-y-0 md:-translate-y-1/2 bg-background/80 backdrop-blur-sm border-primary/20 hover:bg-primary hover:text-primary-foreground transition-colors" />
            <CarouselNext className="static md:absolute right-4 md:-right-12 translate-y-0 md:-translate-y-1/2 bg-background/80 backdrop-blur-sm border-primary/20 hover:bg-primary hover:text-primary-foreground transition-colors" />
          </div>
          
        </Carousel>
      </div>
    </section>;
}